import { render, staticRenderFns } from "./UcInvoiceData.yaml?vue&type=template&id=45cd996b&component"
import script from "./UcInvoiceData.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports